import React, { useEffect, useState } from 'react';
import { useToast } from '../../hooks/useToast';

const ToastItem = ({ toast }) => {
    const { removeToast } = useToast();
    const [isExiting, setIsExiting] = useState(false);

    const handleDismiss = () => {
        setIsExiting(true);
        setTimeout(() => {
            removeToast(toast.id);
        }, 300); // Wait for animation
    };

    // Auto dismiss logic handled by provider, but we could add pause-on-hover here ideally

    const getIcon = () => {
        switch (toast.type) {
            case 'success': return '✅';
            case 'error': return '❌';
            case 'warning': return '⚠️';
            default: return 'ℹ️';
        }
    };

    const getColor = () => {
        switch (toast.type) {
            case 'success': return 'var(--success-color)';
            case 'error': return 'var(--error-color)';
            case 'warning': return 'var(--warning-color)';
            default: return 'var(--primary-color)';
        }
    };

    return (
        <div
            onClick={handleDismiss}
            style={{
                background: '#1a1a1a',
                borderLeft: `4px solid ${getColor()}`,
                borderRadius: '4px',
                padding: '16px',
                marginBottom: '10px',
                color: 'white',
                minWidth: '300px',
                maxWidth: '400px',
                boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                cursor: 'pointer',
                animation: isExiting ? 'slideOut 0.3s forwards' : 'slideIn 0.3s forwards',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            <div style={{ fontSize: '1.2rem' }}>{getIcon()}</div>
            <div style={{ flex: 1, fontSize: '14px' }}>{toast.message}</div>

            <style>{`
                @keyframes slideIn {

                    to { transform: translateX(0); opacity: 1; }
                }
                @keyframes slideOut {
                    from { transform: translateX(0); opacity: 1; }
                    to { transform: translateX(100%); opacity: 0; }
                }
            `}</style>
        </div>
    );
};

const ToastContainer = () => {
    const { toasts } = useToast();

    if (toasts.length === 0) return null;

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
        }}>
            {toasts.map(toast => (
                <ToastItem key={toast.id} toast={toast} />
            ))}
        </div>
    );
};

export default ToastContainer;
